import createApiService from "../../http";
import getStory from "../../story";
import {
  FETCH_COUNTRIES,
  GET_COUNTRY_SUMMARY,
  GET_USERS_LOCATION,
  GET_SLIDER_STATE,
  getVaccinationsEndpoint,
} from "./endpoints";

export const fetchCountriesService = createApiService({
  endpoint: FETCH_COUNTRIES,
  method: "get",
});

export const fetchCountriesFromStoryblokService = () =>
  getStory("", {
    per_page: 100,
    sort_by: "name:asc",
    starts_with: "countries",
  });

export const fetchUsersActiveCountryService = createApiService({
  endpoint: GET_USERS_LOCATION,
  method: "get",
});

export const fetchCountriesVaccinationApi = ({country}) => createApiService({
  endpoint: getVaccinationsEndpoint({country}),
  method: 'get'
})

export const fetchSliderStateService = (params) => createApiService({
  endpoint: GET_SLIDER_STATE,
  method: "get",
  options: {
    params: {
      ...params,
    },
  },
});

export const fetchCountryDonationSummaryService = ({countryId, disease, range}) => createApiService({
  endpoint: `${GET_COUNTRY_SUMMARY}${countryId}/${disease}`,
  method: 'get',
  options: {
    params: {
      countryId,
      disease,
      range,
    },
  },
})
